import { Button as ButtonPrimitive } from '@base-ui/react/button';
import { cn } from 'cn';
import { buttonClass, type ButtonVariant, type ButtonSize } from '../ui/buttonStyles';

type Variant = 'default' | 'outline' | 'secondary' | 'destructive' | 'link' | 'ghost';
type Size = 'default' | 'xs' | 'sm' | 'lg' | 'icon' | 'icon-xs' | 'icon-sm' | 'icon-lg';

const ROLE: Record<Variant, ButtonVariant> = {
  default: 'primary',
  outline: 'secondary',
  secondary: 'secondary',
  destructive: 'danger',
  link: 'link',
  ghost: 'icon',
};

function buttonVariants(variant: Variant = 'default', size?: Size) {
  const sharedSize: ButtonSize | undefined = size === 'xs' || size === 'sm' || size === 'icon-xs' || size === 'icon-sm' ? 'sm' : size ? 'md' : undefined;
  const geometry = size?.startsWith('icon') ? 'aspect-square' : '';
  return cn(buttonClass(ROLE[variant], sharedSize), geometry);
}

function Button({
  className,
  variant = 'default',
  size,
  ...props
}: Omit<ButtonPrimitive.Props, 'title'> & { title: string; variant?: Variant; size?: Size }) {
  return <ButtonPrimitive data-slot="button" className={cn(buttonVariants(variant, size), className)} {...props} />;
}

export { Button, buttonVariants };
